import React, { useMemo } from 'react';
import { graphql } from 'gatsby';

import { default as FooterDS } from 'design-system/src/components/organisms/Footer';

import { useTranslate } from 'gatsby-theme-soluble-source';
import { getSrc } from '../../utils/media';

import { formatLink } from '../../utils/link';

function Footer({ data, layoutProps }: any) {
    const _ = useTranslate();
    const { site, links, bottomLinks, option } = data;

    const footerProps = useMemo(() => {
        return {
            title: site?.siteMetadata?.title,
            textLogoBottom: option?.footerTextLogoBottom,
            ...(option?.footerLogoBottom && {
                logoBottomSrc: getSrc(option.footerLogoBottom),
            }),
            links: !!links?.nodes?.length ? links.nodes.map(formatLink) : [],
            bottomLinks: !!bottomLinks?.items?.length
                ? bottomLinks.items.map(formatLink)
                : [],
            demoSection:
                (!!layoutProps.showBlockDemoSection ||
                    layoutProps.showBlockDemoSectionOnlyMobile) &&
                option.blockDemoSection?.length &&
                option.blockDemoSection[0],
            demoSectionOnlyMobile: layoutProps.showBlockDemoSectionOnlyMobile,
        };
    }, [site, links, bottomLinks, option, layoutProps]);

    return (
        <FooterDS
            text={_['footer.address'].html}
            copyright={_['footer.copyright'].text}
            twitterUrl={_['global.twitter'].text}
            linkedinUrl={_['global.linkedin'].text}
            instagramUrl={_['global.instagram'].text}
            youtubeUrl={_['global.youtube'].text}
            {...footerProps}
        />
    );
}

export default Footer;

export const query = graphql`
    fragment FooterLink on DatoCmsFooter {
        children: label
        title: label
        href
        openInNewWindow
    }
    query Footer($language: String) {
        site {
            siteMetadata {
                title
            }
        }
        links: allDatoCmsFooter(
            filter: {
                label: { in: ["_1", "_2", "_3", "_4"] }
                parent: { id: { eq: null } }
                locale: { eq: $language }
            }
            sort: { position: ASC }
        ) {
            nodes {
                items: treeChildren {
                    ...FooterLink
                    items: treeChildren {
                        ...FooterLink
                    }
                }
            }
        }
        bottomLinks: datoCmsFooter(
            label: { eq: "_bottom" }
            locale: { eq: $language }
            parent: { id: { eq: null } }
        ) {
            items: treeChildren {
                ...FooterLink
            }
        }
        option: datoCmsOption {
            footerLogoBottom {
                ...SourceMedia
                gatsbyImageData(height: 48, placeholder: NONE)
            }
            footerTextLogoBottom
            blockDemoSection {
                ... on DatoCmsBlockDemoSection {
                    ...DatoCmsBlockDemoSection
                }
            }
        }
    }
`;
